import React from "react"

import {FieldViewGroupProps} from "../../../../../render/group/@type"

// const debug = "FieldTaskStatus_ViewGroup"
const debug = false

export default function FieldTaskStatus_ViewGroup(props: FieldViewGroupProps) {

    const value     = props.field.getViewValue(props.model)
    const status    = gd.session.statuses.get(value)
    if (!status) {
        return false
    }

    const classes       = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)
    const iconClasses   = Classes('size-13 border-radius-4 status-color-'+status.color)

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <div className={iconClasses}/>
                </div>
            }
            <div className="max-w-100-percent txt-truncate view-group-label">{props.field.groupLabel(value, props.groupBy)}</div>
        </div>
    )
}



